import { Button, Card, Flex, Heading, Section, Text, TextField } from '@radix-ui/themes'
import { DateFilterMode } from './types'

interface DateFilterSectionProps {
  dateMode: DateFilterMode
  startDate: string
  startTime: string
  onDateModeChange: (mode: DateFilterMode) => void
  onStartDateChange: (date: string) => void
  onStartTimeChange: (time: string) => void
}

export const DateFilterSection = ({
  dateMode,
  startDate,
  startTime,
  onDateModeChange,
  onStartDateChange,
  onStartTimeChange,
}: DateFilterSectionProps) => {
  return (
    <Section className="section-width" size="2">
      <Card>
        <Heading className="date-time-header">Date Filter</Heading>
        <Flex direction="column" gap="3">
          <Flex gap="2">
            <Button
              variant={dateMode === DateFilterMode.RECENT ? 'solid' : 'soft'}
              onClick={() => onDateModeChange(DateFilterMode.RECENT)}>
              Most Recent Imports
            </Button>
            <Button
              variant={dateMode === DateFilterMode.STARTING_FROM ? 'solid' : 'soft'}
              onClick={() => onDateModeChange(DateFilterMode.STARTING_FROM)}>
              Imports Starting From
            </Button>
          </Flex>
          {dateMode === DateFilterMode.STARTING_FROM && (
            <Flex direction="column" gap="2">
              <Text size="2">Select Start Date & Time</Text>
              <Flex gap="2">
                <TextField.Root
                  type="date"
                  value={startDate}
                  onChange={(e) => onStartDateChange(e.target.value)}
                />
                <TextField.Root
                  type="time"
                  value={startTime}
                  onChange={(e) => onStartTimeChange(e.target.value)}
                />
              </Flex>
            </Flex>
          )}
        </Flex>
      </Card>
    </Section>
  )
}
